import { createContext, use, type ReactNode } from "react";
import type { TrpcClient } from "./trpc";

const TrpcClientContext = createContext<TrpcClient | null>(null);

export function TrpcClientProvider({
  client,
  children,
}: {
  client: TrpcClient;
  children: ReactNode;
}) {
  return <TrpcClientContext value={client}>{children}</TrpcClientContext>;
}

export function useTrpcClient(): TrpcClient {
  const client = use(TrpcClientContext);
  if (!client) throw new Error("useTrpcClient must be used within TrpcClientProvider");
  return client;
}
